import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTopView from "../../Components/CustomTopView";
import LeftSideNav from "../../Components/LeftSideNav";
import Loader from "../../Components/Loader";
import TopNavBar from "../../Components/TopNavbar";
import { getMenuDetailsAPI } from "../../Store/Action/menu";
import MenuTable from "./Component/MenuTable";
import Colors from "../../theme/Colors";
import { useNavigate } from "react-router-dom";

const Menus = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rowsPerPageLabel = "Raw Per Pages";
  const { userData } = useSelector((state) => state.user);

  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState(""); // Added searchQuery state
  const [productCategory, setProductCategory] = useState([]);
  const [totalCount, setTotalCount] = useState(1);

  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(false);

  
  const handleChangePage = useCallback((event, newPage) => {
    setPageNumber(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(event.target.value);
    setPageNumber(0);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setPageNumber(0); // Reset to the first page when search changes
  }, []);

  const onAddMenuBtnClick = useCallback(() => {
    navigate("/AddMenu");
  }, [navigate]);


  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/userList", text: "Masters" },
      { key: "2", href: "/menu", text: "Menu" },
    ]);
  }, []);

  useEffect(() => {
    dispatch(
      getMenuDetailsAPI({}, (result) => {
        setMenu(result);
      })
    );
  }, [dispatch]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "20% 80%",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <LeftSideNav />

      <div
        style={{
          backgroundColor: Colors.bgColor,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <TopNavBar
          leftSideText={`Hello ${userData?.data?.user_first_name}`}
          isDashboard={true}
        />

        <CustomTopView
          breadcrumbs={breadcrumbs}
          addButtonText={"Add Customer"}
          exportButtonText={"Export Customer"}
          rowsPerPage={rowsPerPage}
          handleRowsPerPageChange={handleChangeRowsPerPage}
          rowPerPageLabel={rowsPerPageLabel}
          onAddButtonClick={onAddMenuBtnClick}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
        />

        <MenuTable menu={menu} />
      </div>

      <Loader loading={loading} />
    </div>
  );
};

export default Menus;
